import { Crudable } from "kinnect-mixins";
import {
	KActionDialog,
	KDataTable,
	KDataTableMenu,
	KPhoneLink
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default KDataTable.extend( {
	name: "FacilityMaintenanceContactsTable",

	mixins: [ Crudable ],

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no contacts to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching contacts found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "name"
		}
	},

	data: () => ( {
		crud: "facility_maintenance_contacts"
	} ),

	computed: {
		defaultHeaders() {
			return [
				{
					text: "Name",
					value: "name"
				},
				{
					text: "Vendor",
					value: "vendor.nameWithType"
				},
				{
					text: "Location(s)",
					value: "locationNames"
				},
				{
					text: "Phone",
					value: "phone"
				},
				{
					text: "Email",
					value: "email"
				},
				{
					text: "Notes",
					value: "notes"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteContact( contact ) {
			const deleteIndex = this.items.findIndex( item => contact.id === item.id );

			return contact.delete().then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.phone": ( { item } ) => (
					item.phone
						? <KPhoneLink phone={item.phone}></KPhoneLink>
						: "--"
				),

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "facilityMaintenanceContact",
								params: { idContact: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{this.canDelete && <KActionDialog
								confirmButtonColor="error"
								confirmButtonText="Delete"
								loading={this.$wait.is( "delete contact" )}
								onConfirm={() => this.deleteContact( item )}
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								title="Delete Contact"
							>
								Are you sure you want to delete the maintenance contact <strong>{item.name}</strong>?
							</KActionDialog>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
